import { merge } from 'lodash';

/**
 * Base model that provides constructor compatible with spynlBase
 */
export class BaseModel {
  constructor(originalValue?: any) {
    merge(this, originalValue);
  }
}
